import {
  TIMELINE_PROGRESS_FILL_SELECTOR,
  TIMELINE_PROGRESS_TRACK_SELECTOR,
  TIMELINE_STEP_MARKER_SELECTOR,
} from "./constants";
import { createEventManager } from "./eventManager";

const TIMELINE_ALIGN_LINE_SELECTOR = "[data-timeline-align-line]";

// Wrapped step text makes cards taller than the CSS offsets allow for, so the line is measured from the centre of the
// first step marker to the centre of the last one instead.
export const alignTimelineLine = (element) => {
  const container = element.querySelector(TIMELINE_ALIGN_LINE_SELECTOR);

  if (!container) {
    return;
  }

  const lines = [
    TIMELINE_PROGRESS_TRACK_SELECTOR,
    TIMELINE_PROGRESS_FILL_SELECTOR,
  ]
    .map((selector) => container.querySelector(selector))
    .filter(Boolean);
  const markers = [
    ...container.querySelectorAll(TIMELINE_STEP_MARKER_SELECTOR),
  ];

  if (lines.length === 0 || markers.length === 0) {
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const centreOf = (marker) => {
    const markerRect = marker.getBoundingClientRect();

    return markerRect.top + markerRect.height / 2;
  };
  const top = centreOf(markers[0]) - containerRect.top;
  const bottom = containerRect.bottom - centreOf(markers[markers.length - 1]);

  lines.forEach((line) => {
    line.style.top = `${top}px`;
    line.style.bottom = `${bottom}px`;
  });
};

export const createLineAlignment = ({ element, doc, win }) => {
  const events = createEventManager();
  const align = () => alignTimelineLine(element);

  events.add(win, "resize", align);
  doc.fonts?.ready?.then(align);
  align();

  return {
    destroy: () => {
      events.cleanup();
    },
  };
};
